import { render, staticRenderFns } from "./update-random-storage.vue?vue&type=template&id=3cb713cc&scoped=true"
import script from "./update-random-storage.vue?vue&type=script&lang=js"
export * from "./update-random-storage.vue?vue&type=script&lang=js"
import style0 from "./update-random-storage.vue?vue&type=style&index=0&id=3cb713cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb713cc",
  null
  
)

export default component.exports